import { Box } from "@mui/material";

import MultiSelectFilter from "./multi-select-filter";

import type { FC } from "react";
import type ListFilter from "../../types/ListFilter";

export interface StaticFilter extends ListFilter {
  width?: string;
}

interface StaticFilterBarProps {
  filters: StaticFilter[];
  values: Record<number, string[]>;
  onChange: (filterID: number, values: string[]) => void;
}

// Always-visible multi-select filters; the QList's FilterToolbar adds its
// filters from a menu instead.
const StaticFilterBar: FC<StaticFilterBarProps> = ({
  filters,
  values,
  onChange,
}) => (
  <Box
    sx={{
      display: "flex",
      gap: "1.25rem",
      marginLeft: "0.25rem",
      paddingTop: "0.3rem",
      alignSelf: "flex-start",
    }}
  >
    {filters.map((filter) => (
      <Box key={filter.id} sx={{ width: filter.width ?? "14rem" }}>
        <MultiSelectFilter
          variant="outlined"
          label={filter.label}
          options={filter.filter_options}
          selectedValues={values[filter.id]}
          onChange={(selected) => onChange(filter.id, selected)}
          onReset={() => onChange(filter.id, [])}
        />
      </Box>
    ))}
  </Box>
);

export default StaticFilterBar;
